<template>
  <main class="flex min-h-screen items-center justify-center bg-slate-100 p-6 dark:bg-slate-950">
    <div class="w-full max-w-[420px]">
      <router-view></router-view>
    </div>
  </main>
</template>
